import { type HardwareMicButtonPressedPayload } from '@/tauri/dictation/api';
import {
  deviceButtonMappingsAtom,
  dictateMapFunctionalityDialogRequestAtom,
} from '@heidi/dictate/data';
import { getDefaultStore } from 'jotai';

import { handlePreviousField } from './previous-field';

const PREVIOUS_FIELD = 'previous_field';

const resolvedAction = (
  payload: HardwareMicButtonPressedPayload
): HardwareMicButtonPressedPayload['action'] =>
  getDefaultStore().get(deviceButtonMappingsAtom)[payload.deviceKey]?.[
    payload.buttonId
  ] ?? payload.action;

export const handlePreviousFieldPress = (
  payload: HardwareMicButtonPressedPayload
): void => {
  if (getDefaultStore().get(dictateMapFunctionalityDialogRequestAtom) !== null) {
    return;
  }
  if (resolvedAction(payload)?.type !== PREVIOUS_FIELD) {
    return;
  }
  handlePreviousField();
};
